import { getRequest, putRequest } from "../utils/api";

export const ParamsControlService = {
  getParamsInfo: async ({ params_type, params_name, page }) => {
    const limit = page * 36;
    const pageoffset = (page - 1) * 36;

    return await getRequest(`/get-params-info?`, {
      params: { params_type, params_name, limit, pageoffset },
    });
  },
  getInfoByCompany: async ({ company_id, infoparam }) => {
    return await getRequest(`/get-params-info/get?`, {
      params: { company_id, infoparam },
    });
  },
  updateParam: async (body) => {
    
    return await putRequest(`/get-params-info/update`, body, {});
  },
};
